"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InsightCategory {
    constructor({ id, name, description, pcColumnCount, spColumnCount, rowCount, articles, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            description: this.description,
            pcColumnCount: this.pcColumnCount,
            spColumnCount: this.spColumnCount,
            rowCount: this.rowCount,
            articles: this.articles,
        });
        this.id = id;
        this.name = name;
        this.description = description;
        this.pcColumnCount = pcColumnCount;
        this.spColumnCount = spColumnCount;
        this.rowCount = rowCount;
        this.articles = articles;
    }
}
InsightCategory.fromJSON = (json) => {
    const { id, name, description, pcColumnCount, spColumnCount, rowCount, articles } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (description !== null && typeof description !== 'string')
        throw new Error('.description must be a string or null');
    if (typeof pcColumnCount !== 'number')
        throw new Error('.pcColumnCount must be a string');
    if (typeof spColumnCount !== 'number')
        throw new Error('.spColumnCount must be a string');
    if (typeof rowCount !== 'number')
        throw new Error('.rowCount must be a string');
    return new InsightCategory({ id, name, description, pcColumnCount, spColumnCount, rowCount, articles });
};
exports.default = InsightCategory;
